import React from "react";
import shimmerStyle from "./SkinHealthHome.module.scss";
import style from "./HomePageSkeleton.module.scss";

export const HomePageSkeleton = () => {
  return (
    <div data-testid="home-page-skeleton" className={style.skeleton_wrapper}>
      {/* Header */}
      <div data-testid="skeleton-header" className={style.header_block}>
        <div className={`${style.header_title} ${shimmerStyle.shimmer}`} />
        <div className={`${style.header_subtitle} ${shimmerStyle.shimmer}`} />
        <div className={`${style.header_search} ${shimmerStyle.shimmer}`} />
      </div>

      {/* Banner */}
      <div data-testid="skeleton-banner" className={style.banner_block}>
        <div className={style.banner_content}>
          <div className={`${style.banner_title} ${shimmerStyle.shimmer}`} />
          <div className={`${style.banner_text_line1} ${shimmerStyle.shimmer}`} />
          <div className={`${style.banner_text_line2} ${shimmerStyle.shimmer}`} />
          <div className={`${style.banner_btn} ${shimmerStyle.shimmer}`} />
        </div>
        <div className={`${style.banner_image} ${shimmerStyle.shimmer}`} />
      </div>

      {/* Layout Cards */}
      <div data-testid="skeleton-cards-section" className={style.cards_section}>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} data-testid="skeleton-card-box" className={`${style.card_box} ${shimmerStyle.shimmer}`} />
        ))}
      </div>

      {/* Insights & Strategies */}
      <div data-testid="skeleton-insights-section" className={style.insights_section}>
        <div className={`${style.insights_title} ${shimmerStyle.shimmer}`} />
        <div className={style.chip_row}>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} data-testid="skeleton-chip" className={`${style.chip} ${shimmerStyle.shimmer}`} />
          ))}
        </div>
        <div className={style.insights_grid}>
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} data-testid="skeleton-insight-card" className={`${style.insight_card} ${shimmerStyle.shimmer}`} />
          ))}
        </div>
      </div>
    </div>
  );
};
